// Bildirim (Bildirim tablosu, kişisel/pKullanici) satırlarının GÖRSELİ (ikon+renk) ve
// YÖNLENDİRMESİ (tıklanınca hangi rotaya gidilir) — Faz 2 (2026-09): AdminLayout.vue'daki zil
// dropdown'ı + "Tüm Bildirimler" diyaloğu ile Sparqon'un SparqonBildirimDialog'u AYNI mantığı
// kullanır, buraya tekilleştirildi (öncesinde ikisi ayrı ayrı switch-case taşıyordu).

// Bildirim tipine göre ikon + açık zeminli sınıf (K2, Tüm Bildirimler paneli planı §2.3).
// linkType (BagliKayitTipi) üzerinden; aynı "teklif" altında "görüntülendi" ince ayrımı graceful
// (eşleşmezse linkType'a düşer). Okunmuşta da renk KALIR (griye zorlama kalktı, K2 gerekçesi).
// ⚠️ Sınıflar literal yazılır (`bg-${renk}-100` gibi üretilmez) - Tailwind derlemede yalnız
// literal class adlarını görür (tailwind.config.js content taraması).
export function bildirimGorsel(notif) {
  const t = (notif.linkType || "").toString().toLowerCase();
  const tip = (notif.type || "").toString().toLowerCase();
  const metin = (tip + " " + (notif.title || "")).toLowerCase();
  if (t === "teklif") {
    return {
      icon: /görüntül|goruntul/.test(metin) ? "pi pi-eye" : "pi pi-file-edit",
      sinif: "zemin-bilgi renk-bilgi",
    };
  }
  if (t === "siparis") {
    return { icon: "pi pi-shopping-cart", sinif: "zemin-uyari renk-uyari" };
  }
  if (t === "onkayit") {
    return { icon: "pi pi-user-plus", sinif: "zemin-olumlu renk-olumlu" };
  }
  if (t === "talep") {
    return { icon: "pi pi-inbox", sinif: "zemin-olumlu renk-olumlu" };
  }
  if (t === "cagri") {
    return { icon: "pi pi-headphones", sinif: "zemin-bilgi renk-bilgi" };
  }
  if (t === "musteri" || t === "musterihesap" || (t === "" && tip === "cari")) {
    return { icon: "pi pi-wallet", sinif: "zemin-olumlu renk-olumlu" };
  }
  if (t === "urun") {
    return { icon: "pi pi-box", sinif: "zemin-uyari renk-uyari" };
  }
  if (t === "stok") {
    return { icon: "pi pi-exclamation-triangle", sinif: "zemin-olumsuz renk-olumsuz" };
  }
  if (t === "whatsapp" || t === "wp_kota") {
    return { icon: "pi pi-whatsapp", sinif: "zemin-olumlu renk-olumlu" };
  }
  if (t === "ai_sparqonicgoru") {
    return { icon: "pi pi-sparkles", sinif: "zemin-yardim renk-yardim" };
  }
  if (t === "saglik") {
    return { icon: "pi pi-exclamation-triangle", sinif: "zemin-olumsuz renk-olumsuz" };
  }
  if (t === "aikanaldevralma") {
    return { icon: "pi pi-user-edit", sinif: "zemin-bilgi renk-bilgi" };
  }
  return { icon: "pi pi-bell", sinif: "bg-surface-100 text-gray-600 dark:bg-surface-500/15 dark:text-gray-300" };
}

// GetOkunmamisBildirimler/GetBildirimler'in ham satırını (Bildirim_rowid/Baslik/Icerik/...)
// yukarıdaki iki fonksiyonun beklediği { id, title, content, read, time, tarih, type, linkId, linkType }
// şekline çevirir. AdminLayout'un eski _mapNotif'i + _relativeTime'ı ile aynı mantık.
export function bildirimDonustur(item) {
  return {
    id: item.Bildirim_rowid,
    title: item.Baslik,
    content: item.Icerik,
    read: item.Okundu === true || item.Okundu === 1 || item.Okundu === "1" || item.Okundu === "True",
    time: bildirimZamanGoster(item.dtOlusturma),
    tarih: item.dtOlusturma,
    type: item.BildirimTipi,
    linkId: item.BagliKayitID,
    linkType: item.BagliKayitTipi,
  };
}

// Tarih grubu (yalnız Tüm Bildirimler paneli, plan §2.4). Yerel saatle; hafta Pazartesi başlar
// (main.js:354 firstDayOfWeek:1) - bu yüzden Pazartesi/Salı günleri "Bu hafta" doğal olarak boş
// kalır (dünkü gün zaten haftanın başlangıcını kapsıyor). `simdi` parametresi yalnız doğrulamada
// tarihi sahtelemek için.
export function bildirimTarihGrubu(tarih, simdi = new Date()) {
  const t = new Date(tarih).getTime();
  const bugunBaslangic = new Date(simdi.getFullYear(), simdi.getMonth(), simdi.getDate()).getTime();
  const GUN = 86400000;
  const dunBaslangic = bugunBaslangic - GUN;
  const gunIndeksi = simdi.getDay(); // 0 = Pazar .. 6 = Cumartesi
  const pazartesiFarki = gunIndeksi === 0 ? 6 : gunIndeksi - 1;
  const haftaBaslangic = bugunBaslangic - pazartesiFarki * GUN;
  if (t >= bugunBaslangic) return "Bugün";
  if (t >= dunBaslangic) return "Dün";
  if (t >= haftaBaslangic) return "Bu hafta";
  return "Daha eski";
}

// Satır zamanının tooltip'i (v-tooltip.left) - tam tarih/saat.
export function bildirimTamTarih(tarih) {
  return new Date(tarih).toLocaleString("tr-TR", { dateStyle: "long", timeStyle: "short" });
}

export function bildirimZamanGoster(dt) {
  const fark = Date.now() - new Date(dt).getTime();
  const dk = Math.floor(fark / 60000);
  if (dk < 1) return "az önce";
  if (dk < 60) return dk + " dk önce";
  const saat = Math.floor(dk / 60);
  if (saat < 24) return saat + " saat önce";
  const gun = Math.floor(saat / 24);
  if (gun === 1) return "dün";
  if (gun < 7) return gun + " gün önce";
  return Math.floor(gun / 7) + " hafta önce";
}

// BagliKayitTipi (linkType) -> $router.push hedefi. BE'de (BildirimHelper.Ekle çağrıları)
// tek bir sabit liste yok — eşleşmeyen bir tip için null döner (kırık rotaya gitmektense hiçbir
// yere gitmemek tercih edildi).
// SK4-H: Sistem Konsolu'nda (sağlayıcı, kiracı paneli kapalı) yalnız konsolda karşılığı olan
// tipler yönlenir — çağrı konsol Destek masasına; diğerleri kiracı sayfasına gidemeyeceği için null.
export function bildirimRotasi(notif, konsol = typeof window !== "undefined" && window.location.pathname.toLowerCase().startsWith("/sistem")) {
  const t = (notif.linkType || "").toString().toLowerCase();
  if (konsol) {
    if (t === "demo" && notif.linkId) return { path: "/sistem/sirketler/demo-talepler/detay", query: { id: notif.linkId } };
    if (t === "sirket" && notif.linkId) return { path: "/sistem/sirketler/" + notif.linkId }; // SAT: yeni self-servis hesap
    return t === "cagri" && notif.linkId ? { path: "/sistem/destek/cagri", query: { CagriNo: notif.linkId } } : null;
  }
  if (t === "teklif" && notif.linkId) {
    return { path: "/teklif/teklifdetay", query: { TeklifNo: notif.linkId } };
  } else if (t === "siparis" && notif.linkId) {
    return { path: "/talep-teklif-siparis/siparisdetay", query: { SiparisNo: notif.linkId } };
  } else if (t === "talep") {
    return { path: "/talep-teklif-siparis/taleplistesi" };
  } else if (t === "musteri" && notif.linkId) {
    // BD1: cari bildirimleri (ödeme, ön ödeme, mahsup, iade, satış iptali, tahsilat riski, kredi
    // limiti) o müşterinin Ödeme Al sayfasını açar; başka tipte müşteri bildirimi Müşteri Düzenle'ye.
    if ((notif.type || "").toString().toLowerCase() === "cari") {
      return { path: "/islemler/odemeal", query: { pMusteri: notif.linkId } };
    }
    return { path: "/musteri/duzenlemusteri", query: { MusteriNo: notif.linkId } };
  } else if (t === "stok") {
    // TS-ISL-08: ürün formuna değil, Stok Limitleri listesine gider (limiti gözden geçir/düzenle).
    return { path: "/islemler/stok/stoklimitlistesi" };
  } else if (t === "cagri" && notif.linkId) {
    return { path: "/cagri/detaycagri", query: { CagriNo: notif.linkId } };
  } else if (t === "wp_kota") {
    return { path: "/whatsapp/kota" };
  } else if (t === "whatsapp") {
    return { path: /sablon/i.test(notif.type || "") ? "/whatsapp/sablonlar" : "/whatsapp/kota" };
  } else if (t === "saglik" && notif.linkId) {
    // AT-J: AiSaglikKontrol job'unun bildirimi - Şirket Ayarları → AI sekmesine (anahtar/onay burada).
    // SirketNo ZORUNLU (Fable review, finding #1): SirketKayit.vue SirketNo'suz "yeni şirket" moduna
    // açılır, bolum=ai query'si görmezden gelinir (menuBolumler'de ai devre dışı kalır).
    return { path: "/sirket/sirketkayit", query: { SirketNo: notif.linkId, bolum: "ai" } };
  } else if (t === "onkayit") {
    return { path: "/musteri/onkayitform" };
  } else if (t === "ai_sparqonicgoru") {
    // BD1: içgörü kartları Sparqon ana ekranında.
    return { path: "/sparqon" };
  } else if (t === "sirketegec") {
    // BD1: "Destek ekibi hesabınıza giriş yaptı" -> Kullanıcı Ayarları › Oturumlarım.
    return { path: "/kullanici/ayarlar", query: { sekme: "oturumlar" } };
  } else if (t === "aikanaldevralma" && notif.linkId) {
    // AT-C6: insana_devret aracının Bildirim'i - AI Panel Konuşmaları'nda ilgili oturumu açar.
    return { path: "/aipanel/konusmalar", query: { OturumNo: notif.linkId } };
  }
  return null;
}
